import React from 'react';

import { TFormContentComponentProps } from '@/shared/components/ui/form/form-content.types';
import { FormContentRoot } from '@/shared/components/ui/form/form.styled';
import { useScrollFade } from '@/shared/components/ui/scroll-fade/use-scroll-fade/use-scroll-fade';

export const FormContent: React.FC<TFormContentComponentProps> = ({
  $overflowVisible,
  children,
  ...rest
}) => {
  const { ref, fadeTop, fadeBottom } = useScrollFade({
    enabled: !$overflowVisible,
  });

  return (
    <FormContentRoot
      ref={ref}
      $overflowVisible={$overflowVisible}
      $fadeTop={fadeTop}
      $fadeBottom={fadeBottom}
      {...rest}
    >
      {children}
    </FormContentRoot>
  );
};
